// lib/fontawesome.js
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css'; // <-- manual import
config.autoAddCss = false; // <-- disable auto-add
